import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//import Slider from "react-slick";

class Team6 extends Component {

    render() {

        return (
            <>
                <div className="row">
					<div className="col-lg-4 col-md-4 col-sm-6">
						<div className="dlab-box m-b30 dlab-team6">
							<div className="dlab-media">
								<Link to={"#"}>
									<img alt="" src={require("../../images/our-team/pic2.jpg")}/>
								</Link>
							</div>
							<div className="dlab-info">
								<h4 className="dlab-title"><Link to={"#"}>Marco Datella</Link></h4>
								<span className="dlab-position">Designer</span>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-4 col-sm-6">
						<div className="dlab-box m-b30 dlab-team6">
							<div className="dlab-media">
								<Link to={"#"}>
									<img alt="" src={require("../../images/our-team/pic3.jpg")}/>
								</Link>
							</div>
							<div className="dlab-info">
								<h4 className="dlab-title"><Link to={"#"}>Konne Backfield</Link></h4>
								<span className="dlab-position">Developer</span>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-4 col-sm-6">
						<div className="dlab-box m-b30 dlab-team6">
							<div className="dlab-media">
								<Link to={"#"}>
									<img alt="" src={require("../../images/our-team/pic4.jpg")}/>
								</Link>
							</div>
							<div className="dlab-info">
								<h4 className="dlab-title"><Link to={"#"}>Nashid Martines</Link></h4>
								<span className="dlab-position">Manager</span>
							</div>
						</div>
					</div>
				</div>

            </>
        )
    }
}
export default Team6;